module.exports = __webpack_public_path__ + "static/img/logo01.a773662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/robots/jorge5000/logo01.png
// module id = pOjx
// module chunks = 0